export enum PaymentMethod {
  Check = 'check',
  DirectDeposit = 'deposit',
}
